import React, { useEffect, useRef } from 'react';
import wheelImage from './wheel.png';
import arrowImage from './arrow.png';

const PrizeWheel = ({ controller, items }) => {
  const wheelRef = useRef(null);
  const prevItems = useRef(items);

  useEffect(() => {
    if (controller.shouldSpin) {
      const targetIndex = controller.targetIndex;
      const anglePerItem = (2 * Math.PI) / items.length;
      const endAngleForSelectedItem = targetIndex * anglePerItem;
      const randomExtraRotations = (2 + Math.floor(Math.random() * 2)) * (2 * Math.PI);
      const randomDegrees = endAngleForSelectedItem + randomExtraRotations;

      const wheel = wheelRef.current;
      if (wheel) {
        controller.setIsSpinning(true);
        
        // Reset animation
        wheel.style.transition = 'none';
        wheel.style.transform = 'rotate(0)';
        
        // Force reflow
        void wheel.offsetWidth;
        
        // Start animation - fixed position with transform-origin
        wheel.style.transition = `transform ${4 + Math.random() * 2}s cubic-bezier(0.1, 0.1, 0.1, 1.0)`;
        wheel.style.transform = `rotate(${randomDegrees}rad)`;
        
        const handleAnimationEnd = () => {
          if (controller.isSpinning) {
            controller.handleSpinEnd();
          }
          wheel.removeEventListener('transitionend', handleAnimationEnd);
        };
        
        wheel.addEventListener('transitionend', handleAnimationEnd);
      }
    }
  }, [controller.shouldSpin, items.length, controller]);

  useEffect(() => {
    if (items !== prevItems.current) {
      controller.setItems(items);
      prevItems.current = items;
    }
  }, [items, controller]);

  return (
    <div style={{ 
      position: 'relative', 
      width: '400px', // Fixed width
      height: '400px', // Fixed height
      margin: '0 auto' // Center the wheel
    }}>
      {/* Wheel container with fixed position */}
      <div
        ref={wheelRef}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          transformOrigin: 'center center', // Ensure rotation happens around center
        }}
      >
        <img 
          src={wheelImage} 
          alt="Prize Wheel" 
          style={{ 
            width: '100%', 
            height: '100%',
            objectFit: 'contain' 
          }} 
        />
      </div>
      
      {/* Arrow indicator */}
      <div style={{
        position: 'absolute',
        top: '0px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10,
        width: '27px',
        height: '63px'
      }}>
        <img 
          src={arrowImage} 
          alt="Wheel Indicator" 
          style={{ width: '100%', height: '100%' }} 
        />
      </div>
    </div>
  );
};

export default PrizeWheel;